// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__qw9qn","log":"ModalInventoryLogs_log__14YTu","date":"ModalInventoryLogs_date__15G5M","userName":"ModalInventoryLogs_userName__1bQV-"};